import { type FC } from "react";
import { useSelector } from "react-redux";
import { selectBaseDesignation } from "~/features/configurator/Linear/redux/selectors";
import classNames from "classnames";
import Card from "~/common/components/Card";
import { Link, LinkType } from "~/common/components/Link";
import { selectDataComponent } from "~/features/configurator/common/components/ConfigurationSummarySubstep";
import { ToggleIcon } from "~/common/components/icon/ToggleIcon";
import { useTranslation } from "react-i18next";
import { styled } from "~/common/mui";

export const ReviewCard = styled(Card)(({ theme }) => ({
  position: "absolute",
  zIndex: 1250,
  background: theme.palette.common.white,
  right: "-1px",
  top: "100%",
  marginBottom: theme.spacing(3.75),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up("tablet")]: {
    width: "calc(66vw - 16px)",
  },
  [theme.breakpoints.up("desktop-s")]: {
    width: "1208px",
  },
  [theme.breakpoints.up("desktop-m")]: {
    width: "1240px",
  },
  [theme.breakpoints.up("desktop-l")]: {
    width: "1344px",
  },
}));

export const ReviewWrapper = styled("div")(({ theme }) => ({
  "&.active": {
    "& .review-btn, & i": {
      color: theme.palette.primary.main,
    },
  },
}));

export const ReviewBtn = styled("span")({
  fontWeight: "bold",
});

export const ReviewSelected = styled("p")(({ theme }) => ({
  marginTop: theme.spacing(0.625),
  marginBottom: 0,
}));

const ReviewSummaryContainer = styled("div")({
  "& .summary-step": {
    justifyContent: "space-between",
    "& img": {
      marginLeft: "auto",
    },
  },
});

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const LinearProductReviewCard: FC<Props> = ({ setIsOpen }) => {
  const SummaryData = useSelector(selectDataComponent);

  return (
    <ReviewCard>
      <ReviewSummaryContainer>
        <SummaryData isFullReview={false} onStepChange={() => setIsOpen(false)} />
      </ReviewSummaryContainer>
    </ReviewCard>
  );
};
export const LinearProductReviewButton: FC<Props> = ({ isOpen, setIsOpen }) => {
  const baseDesign = useSelector(selectBaseDesignation);

  const { t } = useTranslation();

  const onClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <ReviewWrapper className={classNames("d-flex flex-direction-column", isOpen && "active")}>
      <Link onClick={onClick} variant={LinkType.SECONDARY}>
        <ReviewBtn className={"icon-margin"}>{t("page.linear.summary.review.edit")}</ReviewBtn>
        <ToggleIcon isActive={isOpen} />
      </Link>
      <ReviewSelected>
        <span className={"f-label-color"}>{t("page.linear.summary.review.designType")} </span>
        <span>{baseDesign}</span>
      </ReviewSelected>
    </ReviewWrapper>
  );
};
